import { invoke } from '../../QTBridge';

export const saveImage = (data: { operateType: number; url: string }) => {
  console.log(`call qt: SaveImage. operateType=${data.operateType}`);
  invoke('SaveImage', data).catch((e) => console.error(e));
};
